import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CREATE_POST_CATEGORY } from '@/modules/API/news/news.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../newsSettings.module.scss'

interface AddPostCategoryDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
}

const AddPostCategoryDialog: FunctionComponent<AddPostCategoryDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId
}: AddPostCategoryDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [name, setName] = useState<string>('')

    const [createPostCategory] = useMutation(CREATE_POST_CATEGORY, {
        variables: {
            daycareId,
            name
        },
        onCompleted: () => {
            refetch()
            handleClose()
            setName('')
            showNotificationSuccess(t('postCategoryAdded'))
        },
        onError: () => {
            handleClose()
            setName('')
            showNotificationError(t('postCategoryAddedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('addPostCategory')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={name}
                    setValue={setName}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 1, max: 256 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='add'
                        disabled={name.length < 1 || name.length > 256}
                        onClick={() => createPostCategory()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default AddPostCategoryDialog
